import Loadable from 'react-loadable';

export const LookupRedirectAction = Loadable({
  loader: () => import(/* webpackChunkName: "LookupRedirectAction" */ './LookupRedirectAction'),
  loading: () => null,
});

export { lookupActionProjectResource, lookupActionGoalResource } from './resource';
